import React from 'react';
import { Button, BUTTON_VIEW } from "../../Button";
import { Icon } from "../../Icon";
import { StackView, STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP } from "../../StackView";
import { Text, TEXT_VIEW, TEXT_WEIGHT } from "../../Text";
import { INDENT, View, VIEW_ALIGN } from "../../View";
import { OptionRoot } from '../OptionRoot';
export function createNewItemActionRenderer(_a) {
    var action = _a.action;
    return function footerNewItemActionRenderer(_a) {
        var searchTerm = _a.searchTerm;
        return (React.createElement(OptionRoot, null,
            React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.s, align: STACK_ALIGN.center, distribution: STACK_DISTRIBUTION.lastFill },
                React.createElement(StackView, { direction: STACK_DIRECTION.row, align: STACK_ALIGN.center, distribution: STACK_DISTRIBUTION.start, gap: STACK_GAP.m },
                    React.createElement(View, { spaceVertical: INDENT.s, align: VIEW_ALIGN.center },
                        React.createElement(Text, { view: TEXT_VIEW.primary, truncate: true, weight: TEXT_WEIGHT.bold }, searchTerm)),
                    React.createElement(View, { align: VIEW_ALIGN.center, collapsable: false },
                        React.createElement(StackView, { align: STACK_ALIGN.center, gap: STACK_GAP.s },
                            action.icon && React.createElement(Icon, { src: action.icon }),
                            React.createElement(Button, { ui: BUTTON_VIEW.text, onClick: action.onClick }, action.text)))))));
    };
}
//# sourceMappingURL=footerActionRenderer.js.map